"use client";

import { useEffect } from "react";
export default function Booking() {
  useEffect(() => {
    const scriptId = "calendly-script";
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = "https://assets.calendly.com/assets/external/widget.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);
  return <section id="calendly-booking" className="w-full py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center mb-10 md:mb-12">
          <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground mb-4">
            Prenota una Consulenza
          </h2>
          <p className="text-lg text-muted-foreground font-sans">
            Scegli l'orario migliore per te e prenota una consulenza di 30 minuti con i nostri esperti di immigrazione.
          </p>
        </div>
        
        <div className="w-full max-w-5xl mx-auto bg-card rounded-xl shadow-lg border border-border overflow-hidden">
          <div className="calendly-inline-widget w-full" data-url="https://calendly.com/worldimmigration-ana_delgado/30min" style={{
          minWidth: "320px",
          height: "700px"
        }} />
        </div>
      </div>
    </section>;
}